import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from '../../../styles/theme';
export const StyledTable = styled.div `
  display: table;
  border-collapse: collapse;
  width: 100%;
`;
export const StyledTableTitle = styled.h3 `
  margin: 0;
  padding: ${spacing.medium}px ${spacing.large}px ${spacing.medium}px
    ${spacing.base}px;
  background-color: ${colors.neutralGrey};
  border-bottom: 1px solid ${colors.lightGrey};
  color: ${colors.black};
  font-size: ${fontSizes.root}px;
  font-weight: ${fontWeights.semiBold};

  @media ${query.lessThanMedium} {
    padding: ${spacing.medium}px ${spacing.large}px;
  }
`;
export const StyledRowGroup = styled.ul `
  display: table-row-group;
  margin: 0;
  padding: 0;
  list-style: none;
`;
export const StyledInvisibleRowGroup = styled(StyledRowGroup) `
  visibility: hidden;
  line-height: 0;

  > li {
    // Remove double border
    border-bottom: 0;
  }

  > li > div {
    // Remove vertical space
    padding: 0 ${spacing.base}px;

    & :has([aria-describedby^='tooltip']) {
      // Remove tooltip
      display: none;
    }
  }
`;
export const StyledRow = styled.li `
  display: table-row;
  border-bottom: 1px solid ${colors.lightGrey};
  cursor: ${props => (props.interactive ? 'pointer' : undefined)};
`;
export const StyledColumnHeader = styled.div `
  display: table-cell;
  width: ${props => (props.width ? `${props.width}px` : undefined)};
  padding: ${props => { var _a; return (_a = props.padding) !== null && _a !== void 0 ? _a : `${spacing.base}px`; }};
  font-weight: ${fontWeights.bold};
  text-align: ${props => { var _a; return (_a = props.textAlign) !== null && _a !== void 0 ? _a : 'left'; }};
  vertical-align: top;
`;
export const StyledCell = styled.div `
  display: table-cell;
  padding: ${props => { var _a; return (_a = props.padding) !== null && _a !== void 0 ? _a : `${spacing.base}px`; }};
  vertical-align: middle;
`;
//# sourceMappingURL=subcomponents.js.map